import api from "@/api";

export default {
  get: (type) => {
    if (type === "basic") {
      return api.get("/users/me/profile/basic").then((response) => response);
    } else if (type === "teacher") {
      return api.get("/users/me/profile/teacher").then((response) => response);
    } else if (type === "parent") {
      return api.get("/users/me/profile/parent").then((response) => response);
    }
  },
  getCapabilities: (type) => {
    if (type === "basic") {
      return api
        .options("/users/me/profile/basic")
        .then((response) => response);
    } else if (type === "teacher") {
      return api
        .options("/users/me/profile/teacher")
        .then((response) => response);
    }
  },
  patch: (type, data) => {
    if (type === "basic") {
      return api
        .patch("/users/me/profile/basic", data)
        .then((response) => response);
    } else if (type === "teacher") {
      return api.patch("/users/me/profile/teacher", data);
    } else if (type === "parent") {
      return api
        .patch("/users/me/profile/parent", data)
        .then((response) => response);
    }
  },
  removeThirdPartyAccount: (provider) => {
    return api
      .delete("/users/me/profile/oauths/" + provider)
      .then((response) => response);
  },
  generateNickname: (givenName, surname) => {
    return api
      .get("/users/me/profile/generateNickname?givenName=" + givenName + "&surname=" + surname)
      .then((response) => response);
  },
};
